<template>
    <div class="view" v-if="loaded">
        <h1>Planowane wyłączenie - podgląd</h1>
        <div class="outage-show-container">
            <div class="outage-data">
                <div class="outage-time-box">
                    <div v-for="time,i in report.outageReportTimes" :key="i">
                        <div class="show-outage-row show-outage-row__time">
                            <span class="show-outage-header">Czas rozpoczęcia:</span>
                            <span class="show-outage-data">{{ time.outageStart }}</span>
                        </div>
                        <div class="show-outage-row show-outage-row__time-second">
                            <span class="show-outage-header">Czas zakończenia:</span>
                            <span class="show-outage-data">{{ time.outageEnd }}</span>
                        </div>
                    </div>
                </div>
                <div class="show-outage-row">
                    <span class="show-outage-header">Lista adresów:</span>
                    <ul class="show-outage-data">
                        <li v-for="address in report.addresses" :key="address.address">
                            <b>{{ address.nonFormattedAddress }}</b> - {{ address.street }}
                            {{ address.wesolaDistrict ? "(W)" : "" }}
                            {{ address.streetNumber }}{{ ", " + address.postcode }}
                        </li>
                    </ul>
                </div>
                <div class="show-outage-row">
                    <span class="show-outage-header">Prace do wykonania:</span>
                    <span class="show-outage-data">{{ report.comment }}</span>
                </div>
                <div class="show-outage-row">
                    <span class="show-outage-header">Napięcie:</span>
                    <span class="show-outage-data">
                        {{ report.voltageLevel === "LV" ? "nN" : "" }}
                        {{ report.voltageLevel === "MV" ? "SN" : "" }}
                        {{ report.voltageLevel === "HV" ? "WN" : "" }}
                    </span>
                </div>
                <div class="show-outage-row">
                    <span class="show-outage-header">Data ogłoszenia:</span>
                    <span class="show-outage-data">{{ report.outageAnnouncement }}</span>
                </div>
                <div class="show-outage-row">
                    <span class="show-outage-header">Nr SAP/CallNet</span>
                    <span class="show-outage-data">{{ report.taskNumber }}</span>
                </div>
                <div class="buttons">
                    <router-link v-if="canEditReport"
                                 :to="{name: 'plannedOutageEditByMaster'}">
                        <EonButton label="Edytuj" type="button" />
                    </router-link>
                    <EonButton label="Kopiuj" type="button" @click="copyReport"/>
                    <EonOutlinedButton label="Powrót" type="button" @click="goBack" />
                </div>
            </div>
            <div class="map">
                <EonMapShowArea @emitApi="takeApi" :coords="coords" :coordsArr="coordsArr" />
            </div>
        </div>
    </div>
</template>

<script>
    import DataTable from "primevue/datatable";
    import Column from "primevue/column";
    import EonButton from "@/components/form/EonButton";
    import EonOutlinedButton from "@/components/form/EonOutlinedButton";
    import EonMapShowArea from "@/components/EonMapShowArea";
    import {
        getPlannedOutageById as getReport,
    } from "@/swagger/vue-api-client";
    import {TimeUtils} from "@/utils/TimeUtils";

    export default {
        name: "PlannedOutageReadonlyShowView",

        components: {
            EonButton,
            EonOutlinedButton,
            DataTable,
            Column,
            EonMapShowArea,
        },

        data() {
            return {
                report: {},
                loaded: false,
                nonFormattedReport: {},
                api: null,
                coords: null,
                coordsArr: [],
                canEditReport: false,
            };
        },

        beforeMount() {
            if (this.$route.params.id) {
                getReport({id: this.$route.params.id}).then((response) => {
                    this.report = response.data;
                    this.nonFormattedReport = structuredClone(this.report);
                    const helpCoorArr = [];
                    this.report.addresses.forEach((address) => {
                        helpCoorArr.push(address.coordinates);
                    });
                    this.coordsArr = helpCoorArr;
                    if (response.data.outageReportTimes && response.data.outageReportTimes.length > 0) {
                        response.data.outageReportTimes.forEach((rT) => {
                            if (rT.outageStart) {
                                rT.outageStart = new Date(rT.outageStart)
                                    .toLocaleString("pl-PL", TimeUtils.options);
                            }
                            if (rT.outageEnd) {
                                rT.outageEnd = new Date(rT.outageEnd)
                                    .toLocaleString("pl-PL", TimeUtils.options);
                            }
                        });
                    }
                    if (response.data.outageAnnouncement) {
                        this.report.outageAnnouncement = new Date(response.data.outageAnnouncement)
                            .toLocaleString("pl-PL", TimeUtils.announcementOptions);
                    }
                    if (response.data.createdBy) {
                        this.canEditReport = response.data.createdBy.id === Number(localStorage.getItem("userId"));
                    }
                    this.loaded = true;
                });
            } else {
                this.loaded = true;
            }
        },

        mounted() {
            this.coorFromAddress();
        },

        methods: {
            coorFromAddress(googleMapsApi) {
                if (googleMapsApi) {
                    this.geocoder = new googleMapsApi.Geocoder();
                    if (this.report.addresses) {
                        for (let i = 0; i < this.report.addresses.length; i += 1) {
                            this.geocoder.geocode({
                                address: this.report.addresses[i].nonFormattedAddress,
                            }, (results) => {
                                this.coordinates = {
                                    lng: results[0].geometry.location.lng(),
                                    lat: results[0].geometry.location.lat(),
                                };
                                this.takeCoords(this.coordinates);
                            });
                        }
                    }
                }
            },
            takeApi(value) {
                this.api = value;
                this.coorFromAddress(value);
            },
            takeCoords(value) {
                this.coords = value;
            },
            goBack() {
                this.$router.go(-1);
            },
            copyReport() {
                // eslint-disable-next-line max-len
                localStorage.setItem("copiedReport", JSON.stringify(TimeUtils.adjustResponseBody(this.nonFormattedReport)));
            },
        },
    };
</script>

<style lang="less" scoped>
    .outage-show-container {
        width: 100%;
        display: flex;
        justify-content: center;
        gap: 2%;
        margin-top: 80px;
        .outage-data {
            width: 50%;
        }
        ul.show-outage-data {
            height: 200px;
            max-width: 480px;
            padding-right: 16px;
            overflow-y: auto;
            overflow-x: hidden;
            &:hover::-webkit-scrollbar {
                width: 10px;
            }
        }
        .outage-time-box {
            max-height: 175px;
            padding-right: 16px;
            overflow-y: auto;
            overflow-x: hidden;
            margin-bottom: 30px;
            max-width: 400px;
        }
        .show-outage {
            &-row {
                display: flex;
                gap: 16px;
                margin-bottom: 30px;
                &__time {
                    margin-bottom: 0.5rem;
                    &-second {
                        margin-bottom: 20px;
                    }
                }
            }
            &-header {
                display: block;
                width: 200px;
                text-align: end;
            }
            &-data {
                display: block;
                text-align: start;
                margin: 0;
                max-width: 500px;
                padding: 0;
                li {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
            }
        }
        .buttons {
            display: flex;
            justify-content: center;
            margin-left: 123px;
            gap: 40px;
        }
        .map {
            width: 40%;
            height: 700px;
        }
    }
</style>

<style lang="less">
    @import "../../assets/theme/variable.less";
    .show-outage-table {
        tr {
            th {
                display: none;
            }
            td {
                display: flex;
                width: 100% !important;
                align-items: flex-start;
                gap: 16px;
                .p-column-title {
                    display: block !important;
                }
            }
        }
    }
</style>
